import { get, post, remove } from "./api";
import routes from "./end-points";

export const adminCategoriesApi = {
    initCategories: () => get(routes.admin.categories.init),
    saveChanges: (dto) => post(routes.admin.categories.save, dto),
    delete: (id) => remove(routes.admin.categories.delete(id)),
};
